export const busquedaConstants = {
    BUSCADOR_MAIN_OPTION_SET: 'BUSCADOR_MAIN_OPTION_SET',
    BUSCADOR_RESULTADOS: 'BUSCADOR_RESULTADOS',
    BUSCADOR_FILTROS: 'BUSCADOR_FILTROS',
    BUSCADOR_VERSIONES_MODELO: 'BUSCADOR_VERSIONES_MODELO',
    PRODUCTO_SELECCIONADO: 'PRODUCTO_SELECCIONADO',
    LIMPIAR_PRODUCTO: 'LIMPIAR_PRODUCTO'
};
